export enum RsFormActions {
  syncFormModel = '[rs-form] syncFormModel',
  submitForm = '[rs-form] submitForm',
  saveEvent = 'saveEvent'
}
